import { render, staticRenderFns } from "./discounts.vue?vue&type=template&id=7fcaa446"
import script from "./discounts.vue?vue&type=script&lang=js"
export * from "./discounts.vue?vue&type=script&lang=js"
import style0 from "./discounts.vue?vue&type=style&index=0&id=7fcaa446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports